import { useIsFocused } from '@react-navigation/native';
import React from 'react';

export const withRemountOnFocus = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => {
    return (props) => {
        const [key, setKey] = React.useState(0);
        const isFocused = useIsFocused();
        React.useEffect(() => {
            if (!isFocused) {
                setKey((prevKey) => prevKey + 1);
            }
        }, [isFocused]);
        return (
            <React.Fragment key={key}>
                <Component {...props} />
            </React.Fragment>
        );
    };
};
